import { render, staticRenderFns } from "./RecentlyAdded.vue?vue&type=template&id=3a8922bd&"
import script from "./RecentlyAdded.vue?vue&type=script&lang=js&"
export * from "./RecentlyAdded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports